import { Component, EventEmitter, OnInit, Output, Input, forwardRef, ViewChild } from '@angular/core';
import { Course, Scene } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup, FormControlDirective, ControlContainer } from '@angular/forms';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'scene-selector',
  templateUrl: './scene-selector.component.html',
  styles: [
    `
      .select-container{
        width: 100%;
      }

    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SceneSelectorComponent,
      multi: true
    }
  ]
})
export class SceneSelectorComponent implements OnInit, ControlValueAccessor {
  @Input() course: Course;
  scenes: Scene[];
  select: FormGroup;
  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  @Input()
  formControl: FormControl;
  @Input()
  showNext : boolean;
  @Input()
  formControlName: string;

  constructor(
    private _courseApiService: CoursesAPIService,
    private controlContainer: ControlContainer
  ) {

  }
  get control() {
    return this.formControl || this.controlContainer.control.get(this.formControlName);
  }

  ngOnInit(): void {
    this._courseApiService.getCourseScenes(this.course.id).subscribe(scenes=>{
      this.scenes = scenes;
    })
  }

  registerOnTouched(fn: any): void {
    if (this.formControlDirective) {
      this.formControlDirective.valueAccessor.registerOnTouched(fn);
    }
  }

  registerOnChange(fn: any): void {
    if (this.formControlDirective) {
      this.formControlDirective.valueAccessor.registerOnChange(fn);
    }
  }

  writeValue(obj: any): void {
    if (this.formControlDirective) {
      this.formControlDirective.valueAccessor.writeValue(obj);
    }
  }

}
